import CarouselDonationCards from '@/core/components/CarouselDonationCards/CarouselDonationCards';

export default CarouselDonationCards;
